
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire34b5"];
var parcelRegister = parcelRequire.register;
parcelRegister("g5BNF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bb6a6f4426dec088$export$2e2bcd8739ae039; });
function $bb6a6f4426dec088$var$getInteractionStatus(interaction) {
    var originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    var hasErrors = interaction.errors.length > 0;
    originalInteractionStatus = hasErrors ? 'FAILED' : originalInteractionStatus;
    // `overrideStatus` is to be deprecated - https://product-fabric.atlassian.net/browse/AFO-3760
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: originalInteractionStatus
    };
}
var $bb6a6f4426dec088$export$2e2bcd8739ae039 = $bb6a6f4426dec088$var$getInteractionStatus;

});

parcelRegister("jmxTP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e18a5e20061dd0c0$export$2e2bcd8739ae039; });

var $4gtBF = parcelRequire("4gtBF");
function $e18a5e20061dd0c0$var$getPageVisibilityUpToTTAI(interaction) {
    var start = interaction.start, end = interaction.end;
    return (0, $4gtBF.getPageVisibilityState)(start, end);
}
var $e18a5e20061dd0c0$export$2e2bcd8739ae039 = $e18a5e20061dd0c0$var$getPageVisibilityUpToTTAI;

});

parcelRegister("6m6U8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4a0a273b482dd68a$export$2e2bcd8739ae039; });

var $jmxTP = parcelRequire("jmxTP");
function $4a0a273b482dd68a$export$2e2bcd8739ae039(interaction) {
    var start = interaction.start, end = interaction.end;
    var pageVisibilityUpToTTAI = (0, $jmxTP.default)(interaction);
    return !interaction.abortReason && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
}

});

parcelRegister("ejpCV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a6b6b7fd5a2a3303$export$2e2bcd8739ae039; });

var $gNkVH = parcelRequire("gNkVH");

var $eAzuA = parcelRequire("eAzuA");

var $c3LVh = parcelRequire("c3LVh");

var $as5v9 = parcelRequire("as5v9");

var $03EZb = parcelRequire("03EZb");

var $a48Mt = parcelRequire("a48Mt");

var $g5BNF = parcelRequire("g5BNF");

var $jmxTP = parcelRequire("jmxTP");

var $haRJq = parcelRequire("haRJq");
function $a6b6b7fd5a2a3303$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a6b6b7fd5a2a3303$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a6b6b7fd5a2a3303$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a6b6b7fd5a2a3303$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a6b6b7fd5a2a3303$var$getVCMetrics(_x) {
    return $a6b6b7fd5a2a3303$var$_getVCMetrics.apply(this, arguments);
}
function $a6b6b7fd5a2a3303$var$_getVCMetrics() {
    $a6b6b7fd5a2a3303$var$_getVCMetrics = (0, $eAzuA.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).mark(function _callee(interaction) {
        var _config$vc, _config$vc$ssrWhiteli, _interaction$apdex, _config$vc2, _config$vc3, _result$ufoVcRev;
        var include3p, excludeSmartAnswersInSearch, config, interactionStatus, pageVisibilityUpToTTAI, isPageVisible, shouldReportVCMetrics, observer, includeRawData, isSSREnabled, ssr, tti, prefix, result, mostRecentVCRevision, mostRecentVCRevisionPayload, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c3LVh))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    include3p = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                    excludeSmartAnswersInSearch = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
                    config = (0, $03EZb.getConfig)();
                    if (config !== null && config !== void 0 && (_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
                        _context.next = 5;
                        break;
                    }
                    return _context.abrupt("return", {});
                case 5:
                    if (!(interaction.type !== 'page_load' && interaction.type !== 'transition' && interaction.type !== 'press')) {
                        _context.next = 7;
                        break;
                    }
                    return _context.abrupt("return", {});
                case 7:
                    interactionStatus = (0, $g5BNF.default)(interaction);
                    pageVisibilityUpToTTAI = (0, $jmxTP.default)(interaction);
                    isPageVisible = pageVisibilityUpToTTAI === 'visible';
                    shouldReportVCMetrics = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && isPageVisible; // Use per-interaction VC observer if available, otherwise fall back to global
                    observer = interaction.vcObserver;
                    if (observer) {
                        _context.next = 14;
                        break;
                    }
                    return _context.abrupt("return", {});
                case 14:
                    includeRawData = (0, $as5v9.default)((0, $03EZb.getVCRawDataInteractionRate)(interaction.ufoName, interaction.type));
                    isSSREnabled = interaction.type === 'page_load' && ((config === null || config === void 0 ? void 0 : config.ssr) || (config === null || config === void 0 || (_config$vc$ssrWhiteli = config.vc.ssrWhitelist) === null || _config$vc$ssrWhiteli === void 0 ? void 0 : _config$vc$ssrWhiteli.includes(interaction.ufoName)));
                    ssr = interaction.type === 'page_load' && isSSREnabled ? {
                        ssr: (0, $haRJq.default)(config)
                    } : null;
                    (0, $a48Mt.postInteractionLog).setVCObserverSSRConfig(ssr);
                    tti = (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime;
                    prefix = 'ufo';
                    _context.next = 22;
                    return observer.getVCResult($a6b6b7fd5a2a3303$var$_objectSpread($a6b6b7fd5a2a3303$var$_objectSpread({
                        start: interaction.start,
                        stop: interaction.end,
                        // Use end3p when available to capture raw data observations during 3p holds
                        rawDataStopTime: interaction.end3p,
                        tti: tti,
                        prefix: prefix,
                        includeSSRInV3: (_config$vc2 = config.vc) === null || _config$vc2 === void 0 ? void 0 : _config$vc2.includeSSRInV3,
                        vc: interaction.vc,
                        isEventAborted: interactionStatus.originalInteractionStatus !== 'SUCCEEDED',
                        experienceKey: interaction.ufoName,
                        interactionId: interaction.id,
                        includeSSRRatio: (_config$vc3 = config.vc) === null || _config$vc3 === void 0 ? void 0 : _config$vc3.includeSSRRatio
                    }, ssr), {}, {
                        include3p: include3p,
                        excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                        interactionType: interaction.type,
                        isPageVisible: isPageVisible,
                        includeRawData: includeRawData
                    }));
                case 22:
                    result = _context.sent;
                    observer.stop(interaction.ufoName);
                    if (!include3p) {
                        // For Post Interaction, last interaction should be without 3p
                        (0, $a48Mt.postInteractionLog).setLastInteractionFinishVCResult(result);
                        (0, $a48Mt.interactionExtraMetrics).setLastInteractionFinishVCResult(result);
                    }
                    mostRecentVCRevision = (0, $03EZb.getMostRecentVCRevision)(interaction.ufoName);
                    mostRecentVCRevisionPayload = result === null || result === void 0 || (_result$ufoVcRev = result['ufo:vc:rev']) === null || _result$ufoVcRev === void 0 ? void 0 : _result$ufoVcRev.find(function(_ref) {
                        var revision = _ref.revision;
                        return revision === mostRecentVCRevision;
                    });
                    if (!(!shouldReportVCMetrics || !(mostRecentVCRevisionPayload !== null && mostRecentVCRevisionPayload !== void 0 && mostRecentVCRevisionPayload.clean))) {
                        _context.next = 29;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 29:
                    return _context.abrupt("return", $a6b6b7fd5a2a3303$var$_objectSpread($a6b6b7fd5a2a3303$var$_objectSpread({}, result), {}, {
                        'metric:vc90': mostRecentVCRevisionPayload['metric:vc90']
                    }));
                case 30:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $a6b6b7fd5a2a3303$var$_getVCMetrics.apply(this, arguments);
}
var $a6b6b7fd5a2a3303$export$2e2bcd8739ae039 = $a6b6b7fd5a2a3303$var$getVCMetrics;

});
parcelRegister("haRJq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c80d0cd981cfca13$export$2e2bcd8739ae039; });

var $1CoTB = parcelRequire("1CoTB");
function $c80d0cd981cfca13$var$getSSRDoneTimeValue(config) {
    var _config$ssr, _config$ssr2;
    return config !== null && config !== void 0 && (_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getSSRDoneTime ? config === null || config === void 0 || (_config$ssr2 = config.ssr) === null || _config$ssr2 === void 0 ? void 0 : _config$ssr2.getSSRDoneTime() : $1CoTB.getSSRDoneTime();
}
var $c80d0cd981cfca13$export$2e2bcd8739ae039 = $c80d0cd981cfca13$var$getSSRDoneTimeValue;

});


parcelRegister("lf4za", function(module, exports) {
$parcel$export(module.exports, "getMoreAccuratePageVisibilityUpToTTAI", function () { return $f76e8a6cabd33ca5$export$97ea55623bd7f1ae; });

var $jmxTP = parcelRequire("jmxTP");

var $38JQt = parcelRequire("38JQt");
function $f76e8a6cabd33ca5$export$97ea55623bd7f1ae(interaction) {
    var old = (0, $jmxTP.default)(interaction);
    var buffered = (0, $38JQt.getVisibilityStateFromPerformance)(interaction.end);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}

});
parcelRegister("38JQt", function(module, exports) {
$parcel$export(module.exports, "getVisibilityStateFromPerformance", function () { return $2495ae62070fdc82$export$bcaa23184870682a; });
function $2495ae62070fdc82$export$bcaa23184870682a(stop) {
    try {
        var results = performance.getEntriesByType('visibility-state');
        if (!results || results.length === 0) return null;
        // @ts-ignore
        return results.reduce(function() {
            var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var _ref = arguments.length > 1 ? arguments[1] : undefined, name = _ref.name, startTime = _ref.startTime;
            if (startTime > stop) return acc;
            if (acc === null && name === null) return null;
            if (acc === null) return name;
            if (acc !== name) return 'mixed';
            return acc;
        }, null);
    } catch (_unused) {
        return null;
    }
}

});


parcelRegister("wA1y2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $061eeee217d27ff6$export$2e2bcd8739ae039; });
// Reusable TextEncoder instance to avoid creating new instances
var $061eeee217d27ff6$var$textEncoder = new TextEncoder();
function $061eeee217d27ff6$export$2e2bcd8739ae039(payload) {
    // Early return for null/undefined to avoid unnecessary processing
    if (!payload) return 0;
    // Use the reusable encoder instance
    return Math.round($061eeee217d27ff6$var$textEncoder.encode(JSON.stringify(payload)).length / 1024);
}

});

parcelRegister("c2FBh", function(module, exports) {
$parcel$export(module.exports, "optimizeApdex", function () { return $8c45f0e3b903c717$export$efbacb487c03c9c8; });

var $gNkVH = parcelRequire("gNkVH");

var $lrM5r = parcelRequire("lrM5r");

var $hij2V = parcelRequire("hij2V");
var $8c45f0e3b903c717$var$_excluded = [
    "stopTime",
    "labelStack"
];
function $8c45f0e3b903c717$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c45f0e3b903c717$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c45f0e3b903c717$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c45f0e3b903c717$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8c45f0e3b903c717$export$efbacb487c03c9c8(apdex, reactUFOVersion) {
    return apdex.map(function(_ref) {
        var stopTime = _ref.stopTime, labelStack = _ref.labelStack, others = (0, $lrM5r.default)(_ref, $8c45f0e3b903c717$var$_excluded);
        return $8c45f0e3b903c717$var$_objectSpread($8c45f0e3b903c717$var$_objectSpread({}, others), {}, {
            stopTime: Math.round(stopTime)
        }, labelStack ? {
            labelStack: (0, $hij2V.optimizeLabelStack)(labelStack, reactUFOVersion)
        } : {});
    });
}

});

parcelRegister("lyJgN", function(module, exports) {
$parcel$export(module.exports, "optimizeCustomTimings", function () { return $fb1fe39c38633684$export$967dd9693261321d; });
function $fb1fe39c38633684$export$967dd9693261321d(customTimings, interactionStart) {
    return customTimings.reduce(function(result, item) {
        Object.keys(item.data).forEach(function(key) {
            if (item.data[key].startTime >= interactionStart) result.push({
                labelStack: [
                    {
                        n: key
                    }
                ],
                startTime: Math.round(item.data[key].startTime),
                endTime: Math.round(item.data[key].endTime)
            });
        });
        return result;
    }, []);
}

});

parcelRegister("cxxtC", function(module, exports) {
$parcel$export(module.exports, "optimizeHoldInfo", function () { return $921288dfc1de85bc$export$b983e6c30f3a8c82; });

var $kOzMB = parcelRequire("kOzMB");

var $hij2V = parcelRequire("hij2V");
function $921288dfc1de85bc$export$b983e6c30f3a8c82(holdInfo, interactionStart, reactUFOVersion) {
    var holdInfoMap = holdInfo.reduce(function(result, hold) {
        var labelStack = hold.labelStack, name = hold.name, start = hold.start, end = hold.end, ignoreOnSubmit = hold.ignoreOnSubmit;
        if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
            var label = (0, $hij2V.stringifyLabelStackFully)([].concat((0, $kOzMB.default)(labelStack), [
                {
                    name: name
                }
            ]));
            var startTime = Math.round(start);
            var endTime = Math.round(end);
            var timing = result.get(label) || {
                labelStack: (0, $hij2V.optimizeLabelStack)([].concat((0, $kOzMB.default)(labelStack), [
                    {
                        name: name
                    }
                ]), reactUFOVersion),
                startTime: startTime,
                endTime: endTime
            };
            if (startTime < timing.startTime) timing.startTime = startTime;
            if (endTime > timing.endTime) timing.endTime = endTime;
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return (0, $kOzMB.default)(holdInfoMap.values());
}

});

parcelRegister("lY5jW", function(module, exports) {
$parcel$export(module.exports, "optimizeMarks", function () { return $ffe35428a755f79b$export$4f8106ecc7ec1c7f; });

var $gNkVH = parcelRequire("gNkVH");

var $lrM5r = parcelRequire("lrM5r");

var $hij2V = parcelRequire("hij2V");
var $ffe35428a755f79b$var$_excluded = [
    "labelStack",
    "time"
];
function $ffe35428a755f79b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ffe35428a755f79b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ffe35428a755f79b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ffe35428a755f79b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ffe35428a755f79b$export$4f8106ecc7ec1c7f(marks, reactUFOVersion) {
    return marks.map(function(_ref) {
        var labelStack = _ref.labelStack, time = _ref.time, others = (0, $lrM5r.default)(_ref, $ffe35428a755f79b$var$_excluded);
        return $ffe35428a755f79b$var$_objectSpread($ffe35428a755f79b$var$_objectSpread({}, others), {}, {
            labelStack: labelStack && (0, $hij2V.optimizeLabelStack)(labelStack, reactUFOVersion),
            time: Math.round(time)
        });
    });
}

});

parcelRegister("1x79m", function(module, exports) {
$parcel$export(module.exports, "optimizeReactProfilerTimings", function () { return $11de6b564ac8000c$export$70a658ddbf644d3a; });

var $kOzMB = parcelRequire("kOzMB");

var $a48Mt = parcelRequire("a48Mt");

var $hij2V = parcelRequire("hij2V");
function $11de6b564ac8000c$export$70a658ddbf644d3a(reactProfilerTimings, interactionStart, reactUFOVersion) {
    var reactProfilerTimingsMap = reactProfilerTimings.reduce(function(result, _ref) {
        var labelStack = _ref.labelStack, startTime = _ref.startTime, commitTime = _ref.commitTime, actualDuration = _ref.actualDuration, type = _ref.type;
        if (labelStack && startTime >= interactionStart) {
            var label = (0, $hij2V.stringifyLabelStackFully)(labelStack);
            var start = Math.round(startTime);
            var end = Math.round(commitTime);
            var timing = result.get(label) || {
                labelStack: (0, $hij2V.optimizeLabelStack)(labelStack, reactUFOVersion),
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 0,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = start;
            if (end > timing.endTime) timing.endTime = end;
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            if ((0, $a48Mt.segmentUnmountCache).has(label)) {
                timing.unmountCount = (0, $a48Mt.segmentUnmountCache).get(label) || 0;
                (0, $a48Mt.segmentUnmountCache).delete(label);
            }
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return (0, $kOzMB.default)(reactProfilerTimingsMap.values());
}

});

parcelRegister("lnbBQ", function(module, exports) {
$parcel$export(module.exports, "optimizeRequestInfo", function () { return $f8f4c05a38e2905f$export$9b2c740f95fe352d; });

var $kOzMB = parcelRequire("kOzMB");

var $hij2V = parcelRequire("hij2V");
function $f8f4c05a38e2905f$export$9b2c740f95fe352d(requestInfo, interactionStart, reactUFOVersion) {
    var updatedRequestInfo = requestInfo.reduce(function(result, reqInfo) {
        var labelStack = reqInfo.labelStack, name = reqInfo.name, start = reqInfo.start, end = reqInfo.end, networkStart = reqInfo.networkStart, networkComplete = reqInfo.networkComplete;
        var startTime = networkStart !== null && networkStart !== void 0 ? networkStart : start;
        var endTime = networkComplete !== null && networkComplete !== void 0 ? networkComplete : end;
        if (labelStack && start >= interactionStart && endTime) result.push({
            labelStack: (0, $hij2V.optimizeLabelStack)([].concat((0, $kOzMB.default)(labelStack), [
                {
                    name: name
                }
            ]), reactUFOVersion),
            startTime: Math.round(startTime),
            endTime: Math.round(endTime)
        });
        return result;
    }, []);
    return updatedRequestInfo;
}

});

parcelRegister("g3io0", function(module, exports) {
$parcel$export(module.exports, "optimizeSpans", function () { return $bafb3041e42cc860$export$e69673407fa1f9ed; });

var $kOzMB = parcelRequire("kOzMB");

var $hij2V = parcelRequire("hij2V");
function $bafb3041e42cc860$export$e69673407fa1f9ed(spans, interactionStart, reactUFOVersion) {
    var updatedSpans = spans.reduce(function(result, span) {
        var labelStack = span.labelStack, type = span.type, name = span.name, start = span.start, end = span.end;
        if (labelStack && start >= interactionStart) result.push({
            labelStack: (0, $hij2V.optimizeLabelStack)([].concat((0, $kOzMB.default)(labelStack), [
                {
                    name: name
                }
            ]), reactUFOVersion),
            startTime: Math.round(start),
            endTime: Math.round(end),
            type: type
        });
        return result;
    }, []);
    return updatedSpans;
}

});


//# sourceMappingURL=create-payload.a39ee377.js.map
